import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MainService } from 'src/app/services/main/main.service';
import { SharedService } from 'src/app/services/shared/shared.service';
import { SocketsService } from 'src/app/services/shared/socket.service';
import { SimpleDialogComponent } from 'src/app/shared/simple-dialog/simple-dialog.component';
import { environment } from 'src/environments/environment';
import { ContractDialogComponent } from '../../contract/contract-modal/contract-modal.component';
import { getUserProfile, getUserProfiles, getDoctorSettings, getStoredLocations } from 'src/app/core/session';

@Component({
  selector: 'app-notification-icon',
  templateUrl: './notification-icon.component.html',
  styleUrls: ['./notification-icon.component.scss']
})
export class NotificationIconComponent implements OnInit, OnDestroy, AfterViewInit {
  routing_subs: Subscription;
  button_type = 0 // 0: no button, 1: Pay over time, 2:finance, 3:PP, 4: AR
  userProfileData = localStorage.getItem('userProfileData') ? getUserProfile() : {};
  showSubscription = localStorage.getItem('getFinanceValues')
  ? JSON.parse(localStorage.getItem('getFinanceValues')).data
  : null;
  currentLoc: boolean;
  popup = true;
  allLocations: any;
  profileData: any = {};
  validateInputData = JSON.parse(localStorage.getItem('validateInputData'));
  doctorSettings = getDoctorSettings();
  path:any;
  all_locations = localStorage.getItem('locations') ? getStoredLocations() : [];
  maintenance: any;

  constructor(public dialog: MatDialog, public _socket: SocketsService, public _main: MainService, public router: Router, public _shared: SharedService, private auth: AuthService) {
    this.routing_subs = router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.setButton();
      };
    });
    this.path = window.location.pathname;
    if (this.userProfileData.role_id !== 4 && localStorage.getItem('getFinanceValues')) {
      let financeVal = JSON.parse(localStorage.getItem('getFinanceValues'));
      this.profileData = financeVal.data;
    }
  }

  ngOnInit() {
    this.auth.doctorDefaultVales$.subscribe((data)=>{
      if(data) {
        this.doctorSettings = data;
      }
    })

    this.userProfileData.show_old_version = 0;
    this.currentLoc = window.location.pathname.includes('/app/location');
    this.setButton();
    this._socket.socket.on('new_notification', (data) => {
      this._main.unread_count = data.unread_count;
    })
    this.allLocations = getStoredLocations();
    setTimeout(() => {
      this.popup =  false;
    }, 1000);

    this.auth.maintenanceData.subscribe((ele => {
      this.maintenance = ele;
    }));
    this.auth.unread_count.subscribe((ele)=>{
      if(ele && !this._main.unread_count){
        this._main.unread_count = ele;
      }
    })

  }

  openNotifications() {
    this.dialog.open(ContractDialogComponent, {
      width: '500px',
      panelClass: 'rightFullDialog',
      disableClose: false,
      data: {
        type: 49
      }
    });
  }

  ngOnDestroy() {
    this.routing_subs && this.routing_subs.unsubscribe();
  }

  setButton() {
    this.button_type = 0;
    if ((window.location.pathname.includes('/app/contract')) ||
      (window.location.pathname.includes('/app/contract') && this.userProfileData.role_id == 1)) {
      this.button_type = 2;
    } else if ((window.location.pathname.includes('/app/process-payment/list') && this.userProfileData.show_process_payment == 1) ||
      (window.location.pathname.includes('/app/process-payment/list') && this.userProfileData.role_id == 1) ||
      (window.location.pathname.includes('/app/process-payment/list') && this.profileData.show_payment_process == 1)) {
      this.button_type = 3;
    } else if ((window.location.pathname.includes('/app/accounts-receivable') && this.userProfileData.show_ar == 1) ||
      (window.location.pathname.includes('/app/accounts-receivable') && this.userProfileData.role_id == 1) ||
      (window.location.pathname.includes('/app/accounts-receivable') && this.profileData.show_ar == 1)) {
      this.button_type = 4;
    } else if (window.location.pathname.includes('/app/dashboard')) {
      this.button_type = 1;
    }else if (window.location.pathname.includes('/app/finance-customer') || window.location.pathname.includes('/app/leads')) {
      this.button_type = 5;
    }else if (window.location.pathname.includes('app/process-payment/subscriptions-list')) {
      this.button_type = 6;
    }
  }

  ngAfterViewInit() {
    window.addEventListener('click', (event) => {
      if (this.popup == true && event) {
        this.popup = false;
      }
    })
  }

  show_popup() {
    if (!this.popup) {
      setTimeout(() => {
        this.popup = true;
      }, 100)
    }
  }

  clearLocalStorage(type) {
    if (type == 3 && this.validateInputData && this.validateInputData[0] && this.validateInputData[0].pp_restricted) {
      this._main.customPopups('Please use Have us call you back or contact us at support@denefits.com to enable Process Payment feature.', 1);
      return
    }
    this._main.getRoutes = false;
    this._shared.clearLocalStorage();
    this._shared.clearLeadsData();
    setTimeout(() => {
      let link;
      link = type == 3 ? '/app/process-payment/payment' : (type == 4 ? '/app/accounts-receivable/send-invoice' :  type==6 ? '/app/process-payment/payment' : '/app/finance');
      if (this.userProfileData.role_id == 4) {
        if(type ==4 && !this._main.subscription_global_setting(15)){
          this.openSubLock(1);
        } else if (this.userProfileData.business_verification_state != 'other_info_updated' && link == '/app/accounts-receivable/send-invoice') {
          var getFinanceValues = localStorage.getItem('getFinanceValues') ? JSON.parse(localStorage.getItem('getFinanceValues')) : {};
          var arv2TotalProposals = 0;
          if(Object.keys(getFinanceValues).length > 0){
            arv2TotalProposals = (getFinanceValues && getFinanceValues.data && getFinanceValues.data.contract_count && getFinanceValues.data.contract_count.arv2_contracts) ? getFinanceValues.data.contract_count.arv2_contracts : 0;
          }
          if(arv2TotalProposals > 0){
            this.dialog.open(SimpleDialogComponent, {
              width: '520px',
              panelClass: 'simpleDialog',
              data: {
                type: 44,
                is_ar: 1
              }
            });
          } else {
            this.router.navigate(['/app/accounts-receivable/send-invoice']);
          }
        } else if (this.userProfileData.business_verification_state != 'other_info_updated' && link != '/app/finance') {
          this.dialog.open(SimpleDialogComponent, {
            width: '450px',
            panelClass: 'simpleDialog',
            data: {
              type: 902
            }
          });
        } else {
          if(this.userProfileData.can_finance == 1){
            if (type == 6) {
              this.goToSubscription();
              return
            } else {
              this.router.navigate([link]);
            }
          } else {
            this.router.navigate(['/app/finance-customer']);
          }
        }
      } else {
        this._shared.getSelectedBusiness(link);
      }
    }, 200);
  }

  openSubLock(val){
    this.dialog.open(SimpleDialogComponent, {
      width: '600px',
      disableClose: true,
      panelClass: 'simpleDialog',
      data: {
        type: 101,
        title: '',
        send_data: {
          all_locations: this.all_locations,
          is_ar: val
        }
      }
    });
  }

  goToOldVersion() {
    if (this._socket.socket && this._socket.socket.connected) {
      if (localStorage.getItem('userProfileData')) {
        let profile = getUserProfiles();
        if (profile && profile[0]) {
          this._socket.socket.emit('old_panel', {
            role_id: profile[0].role_id,
            doctor_id: profile[0].doctor_id,
            first_name: profile[0].doctor_first_name,
            last_name: profile[0].doctor_last_name
          });
        }
      }
    }
    window.location.href = `${environment.business_url}/app/initialize?t=${localStorage.getItem('token')}`
  }

  addLocation() {
    let dialogRef = this.dialog.open(ContractDialogComponent, {
      width: '500px',
      panelClass: 'rightFullDialog',
      disableClose: true,
      data: {
        isEdit: false,
        title: 'Add Busniess Owner Details',
        type: 50
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 1) {
        this._main.addBusinessLocation.next(true);
      }
    });
  }

  routeMe(data) {
    if (this.userProfileData.role_id == 4) {
      this.router.navigate([data]);
    }
    else {
      this._shared.getSelectedBusiness('/app/open-api/pay-over-time');
    }
  }

  goToSubscription(){
    if (this.userProfileData.role_id === 4) {
    this.router.navigate(
      ['/app/subscriptions/payment'],
      {
        queryParams: { step: 'overview' }
      }
    );
  }
  }
}
